module.exports = __webpack_public_path__ + "static/media/support-2.8b44cc26.png";